import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-319c086d"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "all-by-topic"
};
const _hoisted_2 = ["element-loading-background"];
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  class: "title"
};
const _hoisted_5 = {
  class: "left-warp"
};
const _hoisted_6 = {
  class: "action-title"
};
const _hoisted_7 = {
  class: "total"
};
const _hoisted_8 = {
  class: "movies-list"
};
const _hoisted_9 = {
  key: 0,
  class: "pagination"
};
const _hoisted_10 = {
  class: "page-span"
};
import { axiosInstanceAll } from '@/api/instance';
import { vodPlusBaseUrl } from '@/utils';
import { inject, onMounted } from 'vue';
import MoviesOrActorItem from './moviesOrActorItem.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'allByTopic',
  props: {
    // modelValue: {
    //   type: Boolean,
    //   default: false
    // },
    title: {
      type: String,
      default: 'By Topic'
    }
  },
  emits: ['onCardClick'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const searchParams = reactive({
      searchValue: '',
      loading: false,
      paginationConfig: {
        page: 0,
        limit: 12,
        total: 0
      }
    });
    const bgTopic = reactive({
      visible: false
    });
    const allMoviesList = ref([]);
    const moviesList = ref([]);

    const getData = async () => {
      console.log('get Data');
      searchParams.loading = true;

      try {
        const {
          subCategoryUrl
        } = currentParams.value;
        const res = await axiosInstanceAll({
          method: 'get',
          url: '/vodPlus' + subCategoryUrl.replace(vodPlusBaseUrl, ''),
          params: {
            usertoken: sessionStorage.getItem('vodPlusToken')
          }
        }); // console.log(res);

        if (res.status == 200) {
          allMoviesList.value = res.data;
          searchParams.paginationConfig.total = res.data.length;
          returnAllPageFunc();
        }
      } catch (error) {
        searchParams.loading = false;
      }
    };

    const handlePaginationChange = val => {
      moviesList.value = [];
      searchParams.paginationConfig.page = val - 1;
      returnAllPageFunc();
    };

    const allByTopicItemClick = item => {
      emit('onCardClick', item);
    };

    onMounted(() => {
      getData();
    });

    const returnAllPageFunc = async () => {
      searchParams.loading = true;
      setTimeout(() => {
        try {
          let newArr = JSON.parse(JSON.stringify(allMoviesList.value));
          moviesList.value = newArr.splice(searchParams.paginationConfig.page * searchParams.paginationConfig.limit, searchParams.paginationConfig.limit);
        } catch (error) {}

        searchParams.loading = false;
      }, 300);
    };

    const currentUiStyleOptions = inject('currentUiStyleOptions');
    const currentParams = inject('currentParams');
    return (_ctx, _cache) => {
      const _component_el_empty = _resolveComponent("el-empty");

      const _component_el_pagination = _resolveComponent("el-pagination");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives((_openBlock(), _createElementBlock("div", {
        class: "default-padding",
        "element-loading-background": _unref(currentUiStyleOptions).bgColor
      }, [!searchParams.loading ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t(__props.title)), 1), _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('Total')) + ": " + _toDisplayString(searchParams.paginationConfig.total), 1)])]), _createElementVNode("div", _hoisted_8, [moviesList.value.length ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(moviesList.value, (item, index) => {
        return _openBlock(), _createBlock(MoviesOrActorItem, {
          infoItem: item,
          onClick: $event => allByTopicItemClick(item),
          poster: item.logo,
          "program-name": item.name
        }, null, 8, ["infoItem", "onClick", "poster", "program-name"]);
      }), 256)) : (_openBlock(), _createBlock(_component_el_empty, {
        key: 1,
        style: {
          "width": "100%"
        },
        "image-size": 50
      }))]), searchParams.paginationConfig.total > searchParams.paginationConfig.limit ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_el_pagination, {
        small: "",
        background: "",
        layout: "slot, prev, pager, next",
        "current-page": searchParams.paginationConfig.page + 1,
        "page-size": searchParams.paginationConfig.limit,
        total: searchParams.paginationConfig.total,
        onCurrentChange: handlePaginationChange
      }, {
        default: _withCtx(() => [_createElementVNode("span", _hoisted_10, _toDisplayString(searchParams.paginationConfig.page * searchParams.paginationConfig.limit + 1 + '-' + (searchParams.paginationConfig.total / (searchParams.paginationConfig.page + 1) > searchParams.paginationConfig.limit ? (searchParams.paginationConfig.page + 1) * searchParams.paginationConfig.limit : searchParams.paginationConfig.total)) + " of " + _toDisplayString(searchParams.paginationConfig.total) + " items ", 1)]),
        _: 1
      }, 8, ["current-page", "page-size", "total"])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 8, _hoisted_2)), [[_directive_loading, searchParams.loading]])]);
    };
  }

});